import AsyncSelect from 'react-select/async';
import { MultiValue } from 'react-select';
import { SearchType } from '../../../data/__generated__/globalTypes';
import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';
import { selectDefaults, useAutoCompleteOptions, useForecastingFilterValidation } from './ForecastingFilters';
import ErrorTooltip from '../ErrorTooltip';
import { ReactComponent as LoadingState } from 'svg/loader.svg';


export default function Publisher() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();
    const loadOptions = useAutoCompleteOptions(SearchType.PUBLISHER);
    const { loading, data } = useForecastingFilterValidation(SearchType.PUBLISHER);

    let tooltip = null;
    if (loading) {
        tooltip = <LoadingState className='inline-flex CampaignSpendOverlayLoadingState h-4 w-4 ml-1' />;
    } else {
        if (data?.filterDependencyValidation) {
            tooltip = (
                <ErrorTooltip id={'publisher-error-tooltip'}>
                    <div>
                        The selected publishers are no longer valid. They may not be available for the selected SSPs.
                    </div>
                </ErrorTooltip>
            );
        }
    }

    return (
        <div className='mt-4 w-80'>
            <div style={{flexDirection: 'row'}}>
                <label
                    htmlFor='publisher'
                    className='inline-block text-sm font-medium text-gray-700'
                >
                    Publisher
                </label>
                {tooltip}
            </div>
            <AsyncSelect
                key={'publisher:' + JSON.stringify(forecastingSettings)}
                isDisabled={isPrimaryForecastingLoading || !forecastingSettings.ssp}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti
                name='publishers'
                className='basic-multi-select'
                classNamePrefix='select'
                onChange={(newValue: MultiValue<{
                    label: string,
                    value: string
                }>) => updateForecastingSetting({ publisherFilter: newValue.map(c => c.value) })}
                defaultOptions
                loadOptions={loadOptions}
                defaultValue={selectDefaults(forecastingSettings.publisherFilter)}
            />
        </div>
    );
}
